import { Spinner, Typography } from '@ui-components/neo.tax';
import { ReactElement } from 'react';
import { Virtuoso, ListRange } from 'react-virtuoso';

import { CenteredStack } from './virtualized-list.styles';

export const VirtualizedList = <Item,>({
  Footer,
  MemoizedRowComponent,
  data,
  height = '100%',
  isLoading,
  loadMore,
  loadMoreRowFromBottomThreshold = 10,
}: {
  data: Item[];
  loadMore?: () => void | PromiseLike<void>;
  MemoizedRowComponent: (props: { index: number; item: Item }) => ReactElement;
  isLoading: boolean;
  loadMoreRowFromBottomThreshold?: number;
  Footer?: () => ReactElement;
  height?: number | string;
}): ReactElement => {
  const handleRangeChanged = (range: ListRange): void => {
    const { endIndex } = range;
    if (data.length - endIndex <= loadMoreRowFromBottomThreshold) {
      loadMore?.();
    }
  };

  const ShownFooter = (): ReactElement => (
    <CenteredStack>
      {isLoading ? (
        <Spinner size="sm" variant="primary" />
      ) : Footer ? (
        <Footer />
      ) : (
        <Typography fontSize="xs">End of list</Typography>
      )}
    </CenteredStack>
  );

  return (
    <Virtuoso
      style={{ height }}
      data={data}
      totalCount={data.length}
      rangeChanged={handleRangeChanged}
      itemContent={(index, item): ReactElement => <MemoizedRowComponent index={index} item={item} />}
      components={{ Footer: ShownFooter }}
    />
  );
};
